/**
 * @generated SignedSource<<f57af0dad91d270dd5debbaa5b059fd9>>
 * @relayHash 23cf7b64de01321e7170c0fa120e85ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 679c77aa946ec0b98347edee8c024c741505aee43363314137e2d7a9f16d84d6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { useLoomConnectedCalendarsQuery } from './useLoomConnectedCalendarsQuery.graphql';

const node: PreloadableConcreteRequest<useLoomConnectedCalendarsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "679c77aa946ec0b98347edee8c024c741505aee43363314137e2d7a9f16d84d6",
    "metadata": {},
    "name": "useLoomConnectedCalendarsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
